import HeroBreadCrumb from "../../components/BreadCrumb/HeroBreadCrumb";
import Paragraph from "../../components/Paragraph/Paragraph";
import SectionBanner from "../../components/SectionBanner/SectionBanner";
import StepperContent from "../../components/StepperContent/StepperContent";
import { WhyUsContent } from "./WhyUs-Content";

const WhyUs: React.FC = () => {
  return (
    <>
      <HeroBreadCrumb
        content={WhyUsContent.heroBreadCrumb}
        style={{ minHeight: "21.875rem" }}
      />
      <section className="container py-4">
        <Paragraph isPageHeader={true} content={WhyUsContent.paragraph1} />
      </section>
      <section className="container py-4">
        <StepperContent content={WhyUsContent.stepperContent} />
      </section>
      <SectionBanner
        linkClass="bg-light-grey2 py-4"
        content={WhyUsContent.sectionBanner}
      />
    </>
  );
};

export default WhyUs;
